export const sectionData = [
    {
        id: 1,
        title: '9 200 фильмов и сериалов',
        text: 'Все эпизоды «Форсажа», включая последний. Смотрите свежие сериалы в день выхода и классику круглый год. За телевизор развернется битва.',
    },
    {
        id: 2,
        title: 'На любых устройствах',
        text: 'Ни на что не хватает времени? Смотрите кино на бегу: в пробке, в метро и даже на работе (лишь бы шеф не заметил). Одно ТВ — для телевизора, компьютера и смартфона.',
    },
    {
        id: 3,
        title: 'Арендуйте или купите',
        text: 'Арендуйте «Бегущего по лезвию» на 48 часов: убежать не успеет. Или оформите месячную подписку и смотрите хоть по пять фильмов в день (только поспать не забудьте!)',
    },
];
